<template>
    <FullscreenDialog
    ref="dialog"
    animation-name="zoomIn"
    :title="$t('pc_biz_o2o_plan_detail' /* 培训计划详情 */)"
    :visible.sync="visible"
    :before-close="(done)=>done(false)">
    <div class="yxtbiz-trainPlanAudit_iframe_wrapper">
    <iframe width="100%"
            height="100%"
            frameborder="0"
            scrolling="auto"
            allowfullscreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            :src="src"></iframe>
    </div>
    </FullscreenDialog>
</template>

<script>
import FullscreenDialog from './fullscreen-dialog.vue';
export default {
  components: {FullscreenDialog},
  data() {
    return {
      visible: false,
      src: ''
    };
  },
  methods: {
    init(planId) {
      this.visible = true;
      this.src = `${window.location.origin}/o2o/#/plandetail/${planId}?from=audit`;
    }
  }
};
</script>